/**
 * nie ma edytora na froncie
 * 
 * @param props 
 */
export default props => {
  return null;
}
